<template>
	<BaseSidebar :title="lock.roomName" @close="$emit('close')">
		<template>
			<!-- Loading - check keys -->
			<div v-if="loading" class="d-flex flex-column align-center">
				<span>Checking keys...</span>
				<v-progress-circular indeterminate />
			</div>
			<template v-else>
				<span @click="validKeys = !validKeys"
					>Keys {{ validKeys ? "V" : "Inv" }}alid</span
				>
			</template>
		</template>

		<template #actions>
			<div class="actions">
				<v-btn outlined tile color="rust-red" :disabled="!validKeys" @click="lockRoom"
					><v-icon class="mr-2">fas fa-lock</v-icon> Lock</v-btn
				>
				<v-btn outlined tile color="ocean" :disabled="!validKeys" @click="unlockRoom"
					><v-icon class="mr-2">fas fa-lock-open</v-icon> Unlock</v-btn
				>
			</div>
			<div v-if="error" class="actions mt-5">
				{{error}}
			</div>
		</template>
	</BaseSidebar>
</template>

<script>
import BaseSidebar from "./Base.vue";
import { mapActions } from "vuex";

export default {
	components: {
		BaseSidebar,
	},

	props: {
		lock: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			loading: false,
			validKeys: false,
			keys: null,
			error: null
		};
	},

	async created() {
		await this.checkout();
	},

	methods: {
		...mapActions({
			_checkout: "locks/checkoutLock",
			_lockRoom: "locks/lockRoom",
			_unlockRoom: "locks/unlockRoom",
		}),

		async checkout() {
			this.loading = true;
			this.validKeys = false;
			try {
				await this._checkout(this.lock.deviceId);
				this.validKeys = true;
			} finally {
				this.loading = false;
			}
		},

		async lockRoom() {
			this.loading = true;
			this.error = null;
			
			try {
				await this._lockRoom(this.lock.deviceId);
			} catch(e) { 
				this.error = `Failed to lock. ${e.message}`;
			} finally {
				this.loading = false;
			}
		},

		async unlockRoom() {
			this.loading = true;
			this.error = null;

			try {
				await this._unlockRoom(this.lock.deviceId);
			} catch(e) { 
				this.error = `Failed to unlock. ${e.message}`;
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.actions {
	display: flex;
	justify-content: space-evenly;

	> * {
		width: 45%;
	}
}
</style>
